import type { MouseEventHandler } from 'react';

export interface NotFoundPageData {
  onBackClick?: MouseEventHandler;
}

export interface NotFoundPageProps extends NotFoundPageData {}
